import React, { useEffect, useState } from "react";
import { Hourglass } from "lucide-react";
import { api } from "../lib/api";

export default function PendingApprovalBanner({ orgName }) {
  const [admins, setAdmins] = useState([]);

  useEffect(() => {
    let alive = true;
    api.get("/org/approval-contacts")
      .then((r) => { if (alive) setAdmins(r.data?.admins || []); })
      .catch(() => { /* silent — banner still works without the contact list */ });
    return () => { alive = false; };
  }, []);

  return (
    <div
      data-testid="pending-approval-banner"
      className="cal-card border-l-4 border-l-[#FF4F00] p-5 mb-6 flex items-start gap-4"
    >
      <Hourglass size={20} className="text-[#FF4F00] mt-0.5 shrink-0" />
      <div className="flex-1">
        <div className="font-mono-cal text-[10px] uppercase tracking-widest text-[#FF4F00] mb-1">
          [PENDING APPROVAL]
        </div>
        <div className="font-display font-bold text-xl leading-tight mb-2">
          Awaiting your organization admin
        </div>
        <p className="text-sm text-[#666]">
          Your account at <strong>{orgName || "your workspace"}</strong> is waiting for an admin
          to authorize you. You&apos;ll be able to create employee profiles and run calibrations as
          soon as they approve. We&apos;ve already notified them by email.
        </p>
        {admins.length > 0 && (
          <div className="mt-4 pt-4 border-t border-[#EEE]" data-testid="approval-contacts">
            <div className="font-mono-cal text-[10px] uppercase tracking-widest text-[#666] mb-2">
              [NUDGE YOUR ADMIN]
            </div>
            <ul className="space-y-1">
              {admins.map((a) => (
                <li key={a.email} className="text-sm text-[#111]">
                  {a.name && <span className="text-[#666]">{a.name} &middot; </span>}
                  <a
                    href={`mailto:${a.email}?subject=${encodeURIComponent(
                      `Access request for ${orgName || "our CALIBRATE workspace"}`
                    )}`}
                    className="underline decoration-[#FF4F00] decoration-2 underline-offset-4 hover:text-[#FF4F00]"
                    data-testid={`approval-contact-${a.email}`}
                  >
                    {a.email}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
